import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { QuestionnaireStatusInfo } from "@/Common/Models/Questionnaires/QuestionnaireStatusInfo";
import { QuestionnaireFormPopup } from "./QuestionnaireFormPopup";
import { QuestionnairePdfPopup } from "./QuestionnairePdfPopup";

interface IQuestionnairePopupControllerProps {
    questionnaire: QuestionnaireStatusInfo;

    onClose: () => void;
    onSubmitted: (result: boolean) => void;
}

class QuestionnairePopupControllerState {
    public showForm: boolean;
}

class QuestionnairePopupController extends BaseReactComponent<IQuestionnairePopupControllerProps, QuestionnairePopupControllerState> {
    constructor(props: IQuestionnairePopupControllerProps) {
        super(props);

        const initialState = new QuestionnairePopupControllerState();
        initialState.showForm = !props.questionnaire.HasResult;
        this.state = initialState;
    }

    public render(): JSX.Element {
        if (!this.props.questionnaire)
            return null;

        const questionnaire = new QuestionnaireStatusInfo(this.props.questionnaire);

        if (this.state.showForm)
            return this.renderForm(questionnaire);

        return this.renderPdf(questionnaire);
    }

    private renderForm(questionnaire: QuestionnaireStatusInfo): JSX.Element {
        return (
            <QuestionnaireFormPopup
                questionnaireInstanceId={questionnaire.QuestionnaireInstanceId}
                onClose={() => this.close()}
                onSubmitted={result => this.submitted(result)}
            />
        );
    }

    private renderPdf(questionnaire: QuestionnaireStatusInfo): JSX.Element {
        return (
            <QuestionnairePdfPopup
                questionnaire={questionnaire}
                onClose={() => this.close()}
                onCorrect={() => this.mutateState(s => s.showForm = true)}
            />
        );
    }

    private close(): void {
        this.props.onClose && this.props.onClose();
    }

    private submitted(result: boolean): void {
        this.props.onSubmitted && this.props.onSubmitted(result);
    }
}

export { QuestionnairePopupController };
